module.exports = __webpack_public_path__ + "img/appImage-signup-forms--1.a8a734b5.svg";